import React, { ChangeEvent } from 'react';
import cn from 'classnames';
import isURL from 'validator/lib/isURL';

import { useTranslation } from '@lyearn/i18n';
import { Box, Button, Input, Typography } from '@lyearn/ui';

import { saveButton } from './styles';

const EditLink = ({
  href,
  setHref,
  onSave,
}: {
  href: string;
  setHref: (event: ChangeEvent<HTMLInputElement>) => void;
  onSave: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Input
        autoFocus={true}
        className="border-none text-text-primary"
        placeholder={t('Common:Tooltips.Link')}
        value={href}
        variant="body-short-02"
        onChange={setHref}
      />
      <Box className="h-24 w-1 bg-border" />
      <Button
        className={cn('mx-4 rounded-4', saveButton)}
        disabled={!isURL(href)}
        variant="ghost"
        onClick={onSave}>
        <Typography variant="heading-xxs">{t('Common:Actions.Save')}</Typography>
      </Button>
    </>
  );
};

export default EditLink;
